export default __webpack_public_path__ + "static/media/mk.fb85539b.svg";